import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Globe, UsersRound, Flag } from 'lucide-react';
import StatusBadge from './StatusBadge';

const prioColor = { low: 'text-zinc-500', medium: 'text-[#002FA7]', high: 'text-red-600' };

export default function TaskCard({ task, assigneeNames = [] }) {
  return (
    <Link
      to={`/tasks/${task.id}`}
      data-testid={`task-card-${task.id}`}
      className="group bg-white border border-zinc-200 p-5 hover:border-black hover:shadow-brutal-sm transition-all flex flex-col gap-3"
    >
      <div className="flex items-start justify-between gap-3">
        <StatusBadge status={task.status} />
        <div className={`flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.15em] ${prioColor[task.priority] || ''}`}>
          <Flag size={12} strokeWidth={2} /> {task.priority}
        </div>
      </div>
      <div className="font-display font-bold text-lg leading-snug text-zinc-900 group-hover:underline decoration-2 underline-offset-4">
        {task.title}
      </div>
      {task.description && (
        <div className="text-sm text-zinc-600 line-clamp-2">{task.description}</div>
      )}
      <div className="mt-auto flex flex-wrap items-center gap-3 pt-3 border-t border-zinc-100">
        {task.is_general ? (
          <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-700">
            <Globe size={12} strokeWidth={2} /> General
          </div>
        ) : (
          <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-700">
            <UsersRound size={12} strokeWidth={2} /> {assigneeNames.length} assigned
          </div>
        )}
        {task.due_date && (
          <div className="flex items-center gap-1 text-[10px] font-mono text-zinc-500">
            <Calendar size={12} strokeWidth={2} /> {task.due_date}
          </div>
        )}
        <div className="ml-auto text-[10px] font-mono text-zinc-500">BY {task.created_by_name?.toUpperCase()}</div>
      </div>
    </Link>
  );
}
